import { Pie } from "react-chartjs-2";
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
} from "chart.js";
import { getPieBackgroundColours, getPieBorderColours } from "./PieChartPalette";


ChartJS.register(ArcElement, Tooltip, Legend);

interface IProps {
    data: PieSegment[];
    title?: string;
}

export default function CrabPie({ data, title }: IProps) {

    const chartData = {
        labels: data.map((m) => m.label),
        datasets: [
            {
                label: "Percentage",
                data: data.map((d) => d.percentage),
                backgroundColor: getPieBackgroundColours(data),
                borderColor: getPieBorderColours(data),
                borderWidth: 1,
            },
        ],
    };

    // New Chart.js options for legend position
    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false, // Important for custom sizing if needed
        plugins: {
            legend: {
                display: true, // Ensure the legend is displayed
                position: 'right' as const, // Position the legend on the right side
                // You can add more styling here if needed
                // labels: {
                //     boxWidth: 20, // Customize color box width
                //     padding: 15, // Padding between legend items
                // }
            },
            tooltip: {
                // Tooltip options if you want to customize them
            }
        }
    };

    return (
        <div style={{ padding: "10px" }}>
            <Pie data={chartData} options={chartOptions} />
        </div>
    );
}
